// extracted by mini-css-extract-plugin
module.exports = {"quoteWrapper":"Quote-module--quoteWrapper--3rEU0","doubleQuotes":"Quote-module--doubleQuotes--nz63_","quote":"Quote-module--quote--18ACP"};